import { embeddedHeaderBg } from "./palette";
import { useThemePreference } from "./useThemePreference";

// Embedded surfaces (browser embed + Teams) draw a chrome-less header that must
// follow the page background across themes, so they take the per-theme hex;
// tenant branding stays constant across themes by design. Raw hex (not a var()
// token) because ThemeHelper.getHeaderTextColor() parses it to pick black/white
// header text. Owns this policy for every themed header — add consumers here
// rather than re-deriving it.
export const useEmbeddedHeaderColor = (isEmbedded: boolean, brandColor?: string): string => {
  const { effective } = useThemePreference();
  return isEmbedded ? embeddedHeaderBg[effective] : brandColor;
};
